import React from 'react';
import c from '../w.js';

const IconChevronDownSmall = React.memo(
  c(
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 13.5859L17.2929 8.29299L18.7071 9.7072L12 16.4143L5.29288 9.7072L6.70709 8.29299L12 13.5859Z"
      }
    )
  )
);

export { IconChevronDownSmall };
